import { EmployeeModuleMenuService } from '@app/modules/employees/services';
import { ChangeRequestService } from '@change-requests/services/change-request.service';
import { DisplayComponentsService } from '@change-requests/services/display-components.service';
import { EmployeeFieldValueService } from '@change-requests/services/employee-field-value.service';
import { InputComponentsService } from '@change-requests/services/input-components.service';

const Services = [
    ChangeRequestService,
    EmployeeFieldValueService,
    DisplayComponentsService,
    InputComponentsService,
    EmployeeModuleMenuService,
];

export { ChangeRequestService, DisplayComponentsService, EmployeeFieldValueService, InputComponentsService, Services };
